/**importing imaage address 
 newss images
*/

import News1 from "./assets/news1.jpg";
import News2 from "./assets/news2.jpg";
import News3 from "./assets/news3.png";
/**importing imaage address 
 social media images
*/
import SM1 from "./assets/SM1.jpg";
import SM2 from "./assets/SM2.jpg";
import SM3 from "./assets/SM3.jpg";

export const newsData = [
    {
     title : "KRAFTON announces pre-registrations for BATTLEGROUNDS MOBILE INDIA",
     date : "2021-05-18",
     img : News1,
    },
    {
        title : "BATTLEGROUNDS MOBILE INDIA Pre-Registrations to start from 18th May on Google Play Store",
        date : "2021-05-18",
        img : News2,
    },
    {
        title : "KRAFTON announces BATTLEGROUNDS MOBILE INDIA",
        date : "2021-05-06",
        img : News3,
    }
];


export const SocialData = [
    {
     title : `BATTLEGROUNDS MOBILE INDIA is finally here! Pre-Register NOW for INDIA KA BATTLEGROUNDS and win exciting rewards!👉  `,
     link : "http://bit.ly/BATTLEG_PRE",
     after : " #PREREGISTERNOW #INDIAKABATTLEGROUNDS #BATTLEGROUNDSMOBILEINDIA",
     date : "2021-05-18",
     img : SM1,
    },
    {
        title : "🪂 Dropping soon on devices near you! What are the items that you miss the most from air drops?",
        after : "#DROPPINGSOON #BATTLEGROUNDSMOBILEINDIA",
        date : "2021-05-17",
        img : SM2,
    },
    {
        title : "Break the chain! Stay home and always wear a mask. Remember to take all precautions and stay safe! ",
        after : "#DoubleMask #StaySafe #BATTLEGROUNDSMOBILEINDIA",
        date : "2021-05-16",
        img : SM3,
    }
];

